import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const DocumentsList = lazy(() => import('../../pages/user_guide/documents/DocumentsList'));

export const UserGuideImport = {
    RoutesMap,
    DocumentsList,
}
